module.exports = __webpack_public_path__ + "img/CDS_logo_clear.704c5916.png";